import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon';
import { RowActions } from 'common/widgets/query-entry-section/components/actions';
import { RowLabel } from 'common/widgets/query-entry-section/components/row-label';
import { Action, FiltersOperator, RowLabelType } from 'common/widgets/query-entry-section/types';
import { ButtonEl } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
/**
 * BaseEntryRow provides the basic elements for every entry type and
 * provides render props for the [selector] and [body rows] from the
 * following layout:
 *
 * ======================================================
 * [drag] [label] | [selector] [overflow] [delete]
 *                | [  body rows (filters, etc)  ]
 * ======================================================
 */

export function BaseEntryRowEl(_ref) {
  let {
    el,
    entry,
    isPlaceholder,
    index,
    rowRenderer
  } = _ref;
  const showLabels = el.attr("row-label-type") !== RowLabelType.None;
  const {
    entryKey
  } = entry;
  const isActive = el.state.activeEntry === index;
  const isDraggingEnabled = el.helpers.isDragEnabled(index);
  return jsx("div", {
    sel: '.mp-query-entry-wrapper',
    attrs: {
      elref: "entryRow"
    }
  }, jsx("div", {
    sel: '.mp-query-entry',
    key: entryKey,
    attrs: {
      draggable: String(isDraggingEnabled),
      disabled: el.attr("disabled")
    },
    class: {
      'is-active': isActive,
      'drop-indicator-above': el.helpers.isDroppingAbove(index),
      'drop-indicator-below': el.helpers.isDroppingBelow(index),
      'indent-drop-indicator': el.helpers.isNestedSection(),
      'is-placeholder': isPlaceholder,
      'is-draggable': el.attr("row-draggable"),
      ["is-".concat(entry.type)]: true
    },
    on: isDraggingEnabled ? {
      dragstart: ev => el.helpers.onEntryStepDragStart(ev, index),
      dragenter: () => el.helpers.onEntryStepDragEnter(index),
      dragover: ev => el.helpers.onEntryStepDragOver(ev, index),
      dragleave: el.helpers.onEntryStepDragClear,
      dragend: el.helpers.onEntryStepDragClear,
      drop: ev => el.helpers.onEntryStepDrop(ev, index)
    } : {}
  }, jsx(rowRenderer.prefixRenderer, {
    el: el,
    index: index
  }), el.attr("row-draggable") ? jsx("div", {
    sel: '.mp-query-entry-gripper',
    class: {
      'is-placeholder': isPlaceholder,
      'is-dragging-disabled': !isDraggingEnabled
    },
    on: {
      mousedown: () => el.helpers.onGripperMouseDown(index),
      mouseleave: el.helpers.onGripperMouseLeave
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "gripper"
    }
  })) : null, showLabels && jsx(RowLabel, {
    el: el,
    index: index,
    entry: entry,
    isPlaceholder: isPlaceholder
  }), jsx("div", {
    sel: '.mp-query-entry-body'
  }, jsx("div", {
    sel: '.mp-query-entry-row.for-selector'
  }, jsx(rowRenderer.selectorRenderer, {
    el: el,
    index: index
  }), jsx(RowActions, {
    el: el,
    entry: entry,
    index: index,
    isPlaceholder: isPlaceholder
  })), jsx(rowRenderer.bodyRowRenderer, {
    el: el,
    index: index
  }))), entry.groupingOperator && jsx("div", {
    sel: '.mp-query-entry-group-operator',
    class: {
      ["is-".concat(entry.groupingOperator)]: true
    }
  }, jsx(ButtonEl, {
    attrs: {
      elref: "entryGroupOperator",
      theme: entry.groupingOperator === FiltersOperator.And ? ButtonTheme.Primary : ButtonTheme.Tertiary,
      role: "button"
    },
    on: {
      click: () => {
        el.updateEntries(Action.Edit, {
          entry: Object.assign(Object.assign({}, entry), {
            groupingOperator: entry.groupingOperator === FiltersOperator.Or ? FiltersOperator.And : FiltersOperator.Or
          }),
          index
        });
      }
    }
  }, entry.groupingOperator)), jsx(rowRenderer.suffixRenderer, {
    el: el,
    index: index
  }));
}